<template>
    <div class="ro-sign-up-box">
        <div
            class="ro-sign-up-box__background"
            v-on:click="closeOverlayBackground"
        ></div>
        <div class="ro-sign-up-box__content">
            <div class="ro-sign-up-close">
                <button
                    class="ro-sign-up-close-button"
                    v-on:click="closeOverlay"
                >
                    <sky-svg name="cross" />
                </button>
            </div>
            <div class="ro-sign-up-box__tab" v-if="openId === 1">
                <div class="ro-sign-up-box__overline">Tilmelding</div>
                <h2>Er du ledig?</h2>
                <div class="ro-sign-up-button-wrap">
                    <div class="ro-sign-up-button" v-on:click="toggleTab(2)">
                        Jeg er ledig
                    </div>
                    <div class="ro-sign-up-button" v-on:click="toggleTab(3)">
                        Jeg er i arbejde
                    </div>
                </div>
            </div>
            <div class="ro-sign-up-box__tab" v-if="openId === 2">
                <h2>Tilmelding for ledige</h2>
                <p>
                    Som ledig kan du tilmelde dig et af vores kurser som 6 ugers
                    jobrettet uddannelse. Kontakt os, så sender vi en
                    tilmeldingsblanket til din e-boks.
                </p>
                <div class="ro-sign-up-button-wrap">
                    <a
                        class="ro-sign-up-button"
                        href="/kurser/kontakt-og-ansatte/"
                        target="_blank"
                        >Kontakt Roskilde Handelsskole</a
                    >
                </div>
            </div>
            <div class="ro-sign-up-box__tab" v-if="openId === 3">
                <h2>{{ courseInfo.title }}</h2>
                <p>Holdstart: {{ courseInfo.start }}</p>
                <p>Tilmelding fortsætter på Voksenuddannelse.dk.</p>
                <div class="ro-sign-up-button-wrap">
                    <a
                        class="ro-sign-up-button"
                        :href="courseInfo.href"
                        target="_blank"
                        >Tilmeld på Voksenuddannelse.dk</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            openId: 1,
        };
    },
    computed: {
        courseInfo() {
            const courseInfo = this.$store.getters["skyOverlay/courseInfo"];

            return courseInfo;
        },
    },

    methods: {
        toggleTab(id) {
            this.openId = id;
        },
        closeOverlayBackground() {
            this.$store.dispatch("skyOverlay/toggle", {
                name: "signUp",
                active: false,
            });
            setTimeout(() => {
                this.openId = 1;
            }, 300);
        },
        closeOverlay() {
            this.$store.dispatch("skyOverlay/toggle", {
                name: "signUp",
                active: false,
            });
            setTimeout(() => {
                this.openId = 1;
            }, 300);
        },
    },
};
</script>



// WEBPACK FOOTER //
// RoSignUpBox.vue?698e49aa